import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors, HttpInterceptorFn } from '@angular/common/http';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import ApPreset from '../appreset';

const ngrokInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('ngrok-free.dev') || req.url.includes('ngrok.io')) {
    const cloned = req.clone({
      setHeaders: {
        'ngrok-skip-browser-warning': 'true'
      }
    });
    return next(cloned);
  }
  return next(req);
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([ngrokInterceptor])
    ),
    provideClientHydration(withEventReplay()),
    MessageService,
    providePrimeNG({ ripple: true, theme: { preset: ApPreset, options: { darkModeSelector: '.dark' } } }),
  ],
};
